import script from "./FontButtonsSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./FontButtonsSelection.vue?vue&type=script&setup=true&lang=js"

import "./FontButtonsSelection.vue?vue&type=style&index=0&id=8132888e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8132888e"]])

export default __exports__